// src/firebaseConfig.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase-Konfiguration
const firebaseConfig = {
  apiKey: "AIzaSyAl1Zq5GNeTzZKstHvJZZFgjnwWe_iIStM",
  authDomain: "brandschutz-app.firebaseapp.com",
  projectId: "brandschutz-app",
  storageBucket: "brandschutz-app.appspot.com",
  messagingSenderId: "513492317567",
  appId: "1:513492317567:web:94dde3a11f03f11529164a"
};

// Firebase initialisieren (nur wenn noch keine App existiert)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Authentifizierung initialisieren
const auth = getAuth(app);

// Firestore initialisieren
const db = getFirestore(app);

// Exporte bereitstellen
export { auth, db, firebaseConfig, app };